export default {
  viewBox: "0 0 24 24",
  paths: [
    "M12.0206 5.63672L13.5403 5.63804L13.5348 11.2927L19.1896 11.2877L19.1909 12.8074L13.5338 12.8117L13.5293 18.3628L12.0096 18.3615L12.0138 12.8127L6.46616 12.8184L6.46484 11.2987L12.0148 11.2937L12.0206 5.63672Z"
  ]
};